import React, { useState, useEffect } from "react";
import { createData } from "../../utility/adminApi";
import CancelIcon from "@mui/icons-material/Cancel";
import { adminAxios } from "../../axiosInstance";
import SelectLabels from "../../components/SelectLabels";

function AddSubcategory({
  setIsLoading,
  setAddtab,
  fetchCategories,
  currentPage,
}) {
  const [loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [formData, setFormData] = useState({
    cat_id: "",
    short_description: "",
  });
  const handleCategoryChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      cat_id: value, // Update the corresponding field in state
    }));
  };

  const fetchProductData = async (page) => {
    try {
      const response = await adminAxios.get("categories");
      const data = response?.data?.data;
      setCategoryData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, []);
  const handleChange = async (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await createData("sub_categories/store", formData);

    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchCategories(currentPage);
      setLoading(false);
      setAddtab(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setAddtab(false)}
        />
      </div>

      <h2 className="text-2xl font-medium text-center">
        Add New Sub-category{" "}
      </h2>
      <form
        onSubmit={handleSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col gap-6 ">
          <div className="flex flex-col w-full ">
            <label htmlFor="Manufacturing Date">Category</label>
            {/* Na here the select */}
            <SelectLabels
              categoryData={categoryData}
              text="Select a Category"
              valueKey="id"
              labelKey="cat_name"
              onSelectChange={handleCategoryChange}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Sub-Category</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="sub Name"
              type="text "
              name="sub_cat_name"
              value={formData.sub_cat_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          disabled={loading}
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {loading ? "Saving..." : "Save Product"}
        </button>
      </form>
    </div>
  );
}

export default AddSubcategory;
